import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Alert, App, Button, Form, Input } from 'antd';
import { api, errorMessage } from '../../api/client';
import { AuthCard } from '../../components/AuthCard';

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const navigate = useNavigate();
  const { message } = App.useApp();
  const [error, setError] = useState<string | null>(token ? null : 'Missing reset token');
  const [loading, setLoading] = useState(false);

  const onFinish = async (values: { password: string }) => {
    setLoading(true);
    setError(null);
    try {
      await api.post('/auth/reset-password', { token, password: values.password });
      message.success('Password updated. Please sign in.');
      navigate('/login', { replace: true });
    } catch (e) {
      setError(errorMessage(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard title="Choose a new password" subtitle="Use at least 10 characters.">
      {error && <Alert type="error" title={error} style={{ marginBottom: 16 }} showIcon />}
      <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
        <Form.Item name="password" label="New password" rules={[{ required: true, min: 10, message: 'At least 10 characters' }]}>
          <Input.Password autoFocus autoComplete="new-password" />
        </Form.Item>
        <Button type="primary" htmlType="submit" block loading={loading} disabled={!token}>
          Update password
        </Button>
      </Form>
      <div style={{ marginTop: 16, textAlign: 'center' }}>
        {error ? <Link to="/forgot-password">Request a new link</Link> : <Link to="/login">Back to sign in</Link>}
      </div>
    </AuthCard>
  );
}
